import { useState, useEffect, useContext } from "react";

import { FiPlus, FiMinus } from "react-icons/fi";

import Select from "react-select";

import { Container } from "./styles";

import QuestionContext from "../../contexts/QuestionContext";
import { AnalistQuestionTypes } from "./types";

function AnalistQuestion({ title, answers, handleSelectSubCat, id }: AnalistQuestionTypes) {
	const [show, setShow] = useState(false);

	const { values, setValues } = useContext(QuestionContext);

	const [subCategories, setSubCategories] = useState([]);
	const [answersOptions, setAnswersOptions] = useState([]);

	useEffect(() => {
		setAnswersOptions(
			answers.map((answer: any) => {
				return { label: answer.title, value: answer.subCategories };
			}),
		);
	}, [answers]);

	const handleChangeValues = (selectedOption: any, type: string) => {
		setValues((state: any) => ({
			...state,
			...{ [id]: { ...state[id], ...{ [type]: selectedOption } } },
		}));
	};

	return (
		<Container>
			<div className='quest' onClick={() => setShow(!show)}>
				<p>{title}</p>
				<div>
					{show === false ? (
						<FiPlus className='img' />
					) : (
						<FiMinus className='img' />
					)}
				</div>
			</div>
			<div className='sub-wrapper'>
				{show === true ? (
					<div className='input-wrapper'>
						<div className='select-wrapper'>
							<p className='select-title'>Resposta</p>
							<Select
								placeholder='Selecione a resposta'
								options={answersOptions}
								value={
									values[id] ? values[id].answer : undefined
								}
								onChange={(selectedOption) => {
									// @ts-ignore
									const options = selectedOption.value.map(
										(subCat: any) => {
											return {
												label: subCat.title,
												value: subCat.title,
												documents: subCat.documents,
											};
										},
									);

									setSubCategories(options);
									handleChangeValues(
										selectedOption,
										"answer",
									);
								}}
								name='answer'
							/>
						</div>
						<div className='select-wrapper'>
							<p className='select-title'>Sub-Categoria</p>
							<Select
								placeholder='Selecione a sub-categoria'
								options={subCategories}
								value={
									values[id] ? values[id].subcat : undefined
								}
								onChange={(selectedOption: any) => {
									// @ts-ignore
									handleSelectSubCat(
										selectedOption.documents,
									);
									handleChangeValues(
										selectedOption,
										"subcat",
									);
								}}
							/>
						</div>
					</div>
				) : null}
			</div>
		</Container>
	);
}

export default AnalistQuestion;
